import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { Container, Reveal } from "./common";
import { useDemoModal } from "./DemoModal";

const FinalCTA = () => {
    const { openDemo } = useDemoModal();
    return (
        <section data-testid="final-cta-banner" className="bg-white px-4 pb-24 pt-4 sm:px-6 lg:px-8">
            <Container>
                <Reveal>
                    <div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#15803D] via-[#16A34A] to-[#166534] px-6 py-16 text-center shadow-2xl shadow-[#16A34A]/25 sm:px-12 lg:py-20">
                        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
                        <div className="pointer-events-none absolute -bottom-32 -right-16 h-80 w-80 rounded-full bg-[#052e16]/40 blur-3xl" />
                        <div
                            className="pointer-events-none absolute inset-0 opacity-[0.12]"
                            style={{
                                backgroundImage:
                                    "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
                                backgroundSize: "26px 26px",
                            }}
                        />
                        <div className="relative">
                            <h2 className="mx-auto max-w-2xl text-balance font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                                Ready to take control of your sales?
                            </h2>
                            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg">
                                Start with a CRM that's simple today and powerful enough
                                for where your business is going.
                            </p>
                            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                                <Link
                                    to="/signup"
                                    data-testid="cta-banner-btn-start-free"
                                    className="group flex items-center gap-2 rounded-full bg-white px-8 py-4 text-[15px] font-bold text-[#15803D] shadow-xl transition-all hover:-translate-y-0.5 hover:shadow-2xl"
                                >
                                    Start Free
                                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                                </Link>
                                <button
                                    onClick={openDemo}
                                    data-testid="cta-banner-btn-book-demo"
                                    className="group flex items-center gap-2 rounded-full border border-white/40 px-8 py-4 text-[15px] font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-white/10"
                                >
                                    <CalendarCheck className="h-4 w-4" />
                                    Book a Demo
                                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                                </button>
                            </div>
                            <p className="mt-6 text-[13px] font-medium text-white/70">
                                No credit card required · 14-day free trial · Cancel anytime
                            </p>
                        </div>
                    </div>
                </Reveal>
            </Container>
        </section>
    );
};

export default FinalCTA;
